import { Hero } from '@/components/home/Hero'
import { Services } from '@/components/home/Services'
import { Process } from '@/components/home/Process'
import { Differentials } from '@/components/home/Differentials'
import { CepChecker } from '@/components/home/CepChecker'
import { Contact } from '@/components/home/Contact'
import { useEffect } from 'react'

const Index = () => {
  useEffect(() => {
    // Smooth scroll for anchor links if loaded with hash
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash)
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      }
    }
  }, [])

  return (
    <div className="w-full overflow-hidden">
      <Hero />
      <Services />
      <Process />
      <Differentials />
      <CepChecker />
      <Contact />
    </div>
  )
}

export default Index
